import { createTheme} from "@mui/material"

export const theme = createTheme({
    typography: {
        button: {
            textTransform: 'none'
        }
    },
    palette: {
        primary: {
            main: "#3f51b5",
        },
        secondary: {
            main: "#a79ce2"
        },
        danger: {
            main: "#F44336"
        },
        warning: {
            main: "#ffeb3b"
        },
        background: {
            main: "#fff"
        },
        text: {
            primary: "#000",
            secondary: "#555"
        }

    }
})